import { render } from "./allproducts.vue?vue&type=template&id=e82fc632&scoped=true"
import script from "./allproducts.vue?vue&type=script&lang=js"
export * from "./allproducts.vue?vue&type=script&lang=js"

import "./allproducts.vue?vue&type=style&index=0&id=e82fc632&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82fc632"]])

export default __exports__